/**
 * index.jsx
 *
 * @Author: apple
 * @Date: 2018/4/13 01:05
 */

import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Pagination } from 'neatui';
import FeedbackItem from './feedbackItem';
import action from '../../reduxModules/action';
import ajax from '../util/ajax';
import './style.module.scss';

class FeedbackList extends React.PureComponent {
  static propTypes = {};

  static defaultProps = {};

  constructor(props, context) {
    super(props, context);
    this.state = {
      readyToCloseId: '',
      total: 0,
      pageNo: 1,
      pageSize: 10,
    };
  }

  componentDidMount() {
    this.fetchFeedbackList();
  }

  toggleDialog = id => {
    this.setState({
      readyToCloseId: id,
    });
  };

  handlePageChange = pageNo => {
    this.setState(
      {
        pageNo,
      },
      () => {
        this.fetchFeedbackList();
      },
    );
  };

  fetchFeedbackList = () => {
    const { initFeedbackList, common } = this.props;
    const { user } = common;
    const { pageSize, pageNo } = this.state;
    const data = {
      pageSize,
      pageNo,
    };
    ajax(
      !user.admin ? '/feedback/feedbackList.do' : '/admin/customer/feedbackList.do',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        data,
      },
      rs => {
        const { code, data } = rs;
        if (code === 1) {
          initFeedbackList('list', data.feedbackList);
          this.setState({
            total: data.totalCount,
          });
        }
      },
      () => {},
      false,
      false,
      false,
    );
  };

  render() {
    const { stone, common } = this.props;
    const { readyToCloseId, total, pageSize, pageNo } = this.state;
    const { unReadList } = stone;
    return (
      <div>
        <ul styleName="customer-feedback">
          {stone.list.map(item => {
            const unreadState = !!unReadList.filter(unReadItem => unReadItem === item.id).length;
            return (
              <FeedbackItem
                {...item}
                toggleDialog={this.toggleDialog}
                readyToCloseId={readyToCloseId}
                userImg={common.user.icon}
                key={item.id}
                unreadState={unreadState}
                passport={common.user.realUserId}
              />
            );
          })}
        </ul>
        <Pagination
          total={total}
          showQuickJump
          pageSize={pageSize}
          current={pageNo}
          onChange={this.handlePageChange}
          scrollToTop
        />
      </div>
    );
  }
}

export default connect(
  state => ({
    stone: state.feedbackList,
    common: state.common,
  }),
  dispatch =>
    bindActionCreators(
      {
        initFeedbackList: action.initFeedbackList,
      },
      dispatch,
    ),
)(FeedbackList);
